import type { IUptimeData } from '@/data'

export const generateSampleUptimeData = (
  serviceId = 'celestia-cosmos',
): IUptimeData[] => {
  const data: IUptimeData[] = []
  const now = new Date()

  // 90 days * 24 hours * 12 (every 5 minutes) = 25,920 data points
  // const totalPoints = 90 * 24 * 12
  const totalPoints = 4389

  // Target: 99.6% uptime (0.3% slow, 0.1% down)
  const downPoints = Math.floor(totalPoints * 0.0001) // 0.1% down
  const slowPoints = Math.floor(totalPoints * 0.003) // 0.3% slow
  const upPoints = totalPoints - downPoints - slowPoints

  // Create status distribution
  const statusDistribution: Array<'up' | 'slow' | 'down'> = [
    ...Array(upPoints).fill('up'),
    ...Array(slowPoints).fill('slow'),
    ...Array(downPoints).fill('down'),
  ]

  // Shuffle for random distribution
  for (let i = statusDistribution.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[statusDistribution[i], statusDistribution[j]] = [
      statusDistribution[j],
      statusDistribution[i],
    ]
  }

  // Generate data points every 5 minutes
  for (let i = 0; i < totalPoints; i++) {
    const timestamp = new Date(
      now.getTime() - (totalPoints - 1 - i) * 5 * 60 * 1000,
    )
    const status = statusDistribution[i]

    let responseTime: number
    let statusCode: number
    let error: string

    switch (status) {
      case 'up':
        // Target average ~35ms with normal distribution
        responseTime = Math.max(
          15,
          Math.min(80, 35 + (Math.random() - 0.5) * 30),
        )
        statusCode = 200
        error = ''
        break

      case 'slow':
        // Slow responses: 100-800ms
        responseTime = 100 + Math.random() * 700
        statusCode = 200
        error = ''
        break

      default:
        // Request timeout scenarios
        responseTime = 5000 + Math.random() * 10000 // 5-15 seconds
        statusCode = 408 // Request Timeout
        error =
          'Request timeout - server did not respond within expected timeframe'
        break
    }

    data.push({
      id: `check-${serviceId}-${i.toString().padStart(6, '0')}`,
      serviceId,
      timestamp,
      status,
      responseTime: Math.round(responseTime * 100) / 100,
      statusCode,
      error,
    })
  }

  return data
}
